var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"0","color":_vm.color}},[_c('v-card-text',{staticClass:"text-center"},[_c('div',{staticClass:"text--header-l my-0"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"text--caption"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }